import { createGlobalStyle, css } from 'styled-components';

import themeColors from '@polyai/ui/styles/config/colors';

import { DateRangePickerStyles } from 'components/molecules/DateRangePicker/DateRangePicker.styled';

const CYPRESS = process.env.NEXT_PUBLIC_CYPRESS;

import 'rsuite/dist/rsuite-no-reset.min.css';

const GlobalStyle = createGlobalStyle`  
  html {
    scroll-behavior: unset;

    overflow: hidden auto;

    font-family: ${({ theme }) => theme.text.font.body};
    font-display: block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color:  ${themeColors.textPrimary};

    background: ${themeColors.backgroundPage};

    -webkit-tap-highlight-color: transparent; /* for removing the highlight on tap/touch */
  }

  /* Prevent 2-finger swipe to trigger history.back in chrome */
  html,
  body {
    overscroll-behavior-x: none;
  }

  body {
    height: 100%;
    min-height: 100vh;
  }

  body.noscroll {
    position: fixed;
    inset: 0;
    overflow: hidden;
  }

  #root {
    height: 100%;
    min-height: 100vh;
  }

  .focussed {
    outline: 1px solid ${themeColors.borderBrand};
  }

  .error {
    color: ${themeColors.errorText01};
  }

  .skeletonInFlexContainer {
    flex: 1;
  }

  ${DateRangePickerStyles}

  /* don't display error overlay if it's a cypress test run */
  ${
    CYPRESS &&
    css`
      iframe {
        display: none;
      }
    `
  }
  `;

export default GlobalStyle;
